module.exports = __webpack_public_path__ + "img/tick.91f82083.svg";